import type { LoaderFunctionArgs } from 'react-router';

import { CategoryRouteComponent } from '@jane/bloom/components/routes/category/categoryRouteComponent';
import { loadCategoryRoute } from '@jane/bloom/loaders/routes/category.server';

export {
  clientLoader,
  links,
  meta,
} from '@jane/bloom/routes/_menu.($storeSlug).shop-all._index/route';
export { productGridShouldRevalidate as shouldRevalidate } from '@jane/bloom/utils/routes/shouldRevalidate';

export const loader = async (args: LoaderFunctionArgs) =>
  loadCategoryRoute({ args, shouldPinStore: true });

export default CategoryRouteComponent;
